import { AxiosError } from "axios";
import { IGCPBigQueryJob } from "../../../Models/IGCPBigQueryJob";
import { IMyReportsReport } from "../../../Models/IMyReportsReport";
import { App } from "../Enums/App";
import { IReportProgress } from "../Models/IReportProgress";
import { IGetJobsRequest } from "../Models/Requests/IGetJobsRequest";
import {
    DeleteReportInitiateAction,
    DELETE_REPORT_INITIATE,
    GetRecentReportsSuccessAction,
    GetRecentMatchReportsSuccessAction,
    GetRecentMobilyticsReportsSuccessAction,
    GetRecentReportsFailureAction,
    GetRecentReportsInitiateAction,
    GetReportsFailureAction,
    GetReportsInitiateAction,
    GetReportsSuccessAction,
    GET_RECENT_REPORTS_SUCCESS,
    GET_RECENT_MATCH_REPORTS_SUCCESS,
    GET_RECENT_MOBILYTICS_REPORTS_SUCCESS,
    GET_RECENT_REPORTS_FAILURE,
    GET_RECENT_REPORTS_INITIATE,
    GET_REPORTS_FAILURE,
    GET_REPORTS_INITIATE,
    GET_REPORTS_SUCCESS,
    SetDeletingReportAction,
    SetDeletingReportSuccessAcction,
    SetLoadingReportsAction,
    SetReportProgress,
    SET_DELETING_REPORT,
    SET_DELETING_REPORT_SUCCESS,
    SET_LOADING_REPORTS,
    SET_REPORT_PROGRESS
} from "../Types/ReportActionTypes";

/** misc */
export const setLoadingReports = (loading: boolean): SetLoadingReportsAction => ({
    type: SET_LOADING_REPORTS,
    data: loading,
});
export const setDeletingReport = (deleting: boolean): SetDeletingReportAction => ({
    type: SET_DELETING_REPORT,
    data: deleting,
});
export const setReportProgress = (progress: IReportProgress): SetReportProgress => ({
    type: SET_REPORT_PROGRESS,
    data: progress,
});
/** initiate */
export const deleteReportInitiate = (
    jobId: string,
): DeleteReportInitiateAction => ({
    type: DELETE_REPORT_INITIATE,
    data: jobId,
});
export const getReportsInitiate = (
    request: IGetJobsRequest,
): GetReportsInitiateAction => ({
    type: GET_REPORTS_INITIATE,
    data: request,
});
export const getRecentReportsInitiate = (
    app: App,
): GetRecentReportsInitiateAction => ({
    type: GET_RECENT_REPORTS_INITIATE,
    data: app,
});
/** success */
export const getReportsSuccess = (
    reports: IMyReportsReport[],
): GetReportsSuccessAction => ({
    type: GET_REPORTS_SUCCESS,
    data: reports,
});
export const getRecentReportsSuccess = (
    reports: IGCPBigQueryJob[],
): GetRecentReportsSuccessAction => ({
    type: GET_RECENT_REPORTS_SUCCESS,
    data: reports,
});
export const getRecentMatchReportsSuccess = (
    reports: IGCPBigQueryJob[],
): GetRecentMatchReportsSuccessAction => ({
    type: GET_RECENT_MATCH_REPORTS_SUCCESS,
    data: reports,
});
export const getRecentMobilyticsReportsSuccess = (
    reports: IGCPBigQueryJob[],
): GetRecentMobilyticsReportsSuccessAction => ({
    type: GET_RECENT_MOBILYTICS_REPORTS_SUCCESS,
    data: reports,
});
export const setDeletingReportSuccess = (
    jobId: string,
): SetDeletingReportSuccessAcction => ({
    type: SET_DELETING_REPORT_SUCCESS,
    data: jobId,
});
/** failure */
export const getReportsFailure = (error: AxiosError): GetReportsFailureAction => ({
    type: GET_REPORTS_FAILURE,
    data: error.message,
});
export const getRecentReportsFailure = (error: AxiosError): GetRecentReportsFailureAction => ({
    type: GET_RECENT_REPORTS_FAILURE,
    data: error.message,
});
